import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-vertical-highlight-bar',
	templateUrl: './vertical-highlight-bar.component.html',
	styleUrls: ['./vertical-highlight-bar.component.scss']
})
export class VerticalHighlightBarComponent {
	@Input() height : string = "auto"
}
